<template>
    <div>
        <test-environment-banner
            v-if="$app.ProgramInfo.IsTestProgram"
            v-bind:message="testEnvironmentMessage" />
        <test-environment-active-warning
            v-if="bannerModel.ShowTestEnvironmentActiveWarning"
            v-bind:message="testEnvironmentActiveWarning" />
        <cp-admin-production-banner v-if="bannerModel.ShowCpAdminWarning" />
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="bannerModel.MaintenanceMessage" />
        <!-- eslint-enable vue/no-v-html -->
        <system-message-banner
            v-if="bannerModel.SystemMessageContent"
            v-bind:banner-content-model="bannerModel.SystemMessageContent" />
        <reflow-banner
            v-if="bannerModel.ShowReflowBanner"
            v-bind:cols-key="bannerModel.ReflowBannerCOLSKey" />
        <pc-alert
            v-if="bannerModel.AdminBannerEnabled"
            v-bind:severity="alertSeverity"
            shown
            class="mb-0">
            <div class="d-flex align-items-center w-100">
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="flex-grow-1 text-center"
                    v-html="bannerModel.AdminBannerText" />
                <!-- eslint-enable vue/no-v-html -->
            </div>
        </pc-alert>
    </div>
</template>

<script>
    import testEnvironmentBanner from "Menu/Banners/testEnvironmentBanner.vue";
    import cpAdminProductionBanner from "Menu/Banners/cpAdminProductionBanner.vue";
    import testEnvironmentActiveWarning from "Menu/Banners/testEnvironmentActiveWarning.vue";
    import reflowBanner from "Menu/Banners/reflowBanner.vue";
    import systemMessageBanner from "Menu/Banners/systemMessageBanner.vue";
    import { BANNER_STYLE } from "Menu/Banners/banners";
    import { ALERT_SEVERITY } from "Util/alerts";
    import { KEYS, NAMESPACE } from "Menu/i18n/navbar.i18n";
    import { mapI18n } from "Util/i18n";

    /*
    Not ported from the existing banners:
    - Dismissible banner (not used?)
    - Reflow banner
    - Browser unsupported banner (blocked on login)
    - CPAdmin maintenance banner (not used, deprecated?)
    */
    export default {
        components: {
            testEnvironmentBanner,
            cpAdminProductionBanner,
            testEnvironmentActiveWarning,
            reflowBanner,
            systemMessageBanner
        },
        props: {},
        computed: {
            bannerModel() {
                return this.$app.NavbarBannerModel;
            },
            alertSeverity() {
                switch (this.bannerModel.AdminBannerStyleId) {
                    case BANNER_STYLE.info:
                        return ALERT_SEVERITY.info;
                    case BANNER_STYLE.warning:
                        return ALERT_SEVERITY.warning;
                    case BANNER_STYLE.error:
                        return ALERT_SEVERITY.error;
                    default:
                        return ALERT_SEVERITY.info;
                }
            },
            ...mapI18n(KEYS, NAMESPACE)
        }
    };
</script>
